module.exports = __webpack_public_path__ + "staticcomp/img/share.70a2a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/share.jpg
// module id = dlYC
// module chunks = 39